import { Button as AntDesignButton, Image } from 'antd';
import cx from 'classnames';
import React from 'react';

import GoogleLogo from '../../images/icons/icon_google.svg';
import MailIcon from '../../images/icons/icon_mail.svg';
import MicrosoftLogo from '../../images/icons/icon_microsoft.svg';
import styles from './_SocialButton.module.scss';

type SocialProvider = 'google' | 'microsoft' | 'email';

type SocialButtonProps = {
  onClick?: () => void;
  provider: SocialProvider;
  label?: string;
  loading?: boolean;
  disabled?: boolean;
};

const getSvgSource = (provider: SocialProvider) => {
  if (provider === 'microsoft') {
    return MicrosoftLogo;
  }

  if (provider === 'google') {
    return GoogleLogo;
  }

  if (provider === 'email') {
    return MailIcon;
  }

  return '';
};

const getIconImage = (provider: SocialProvider) => {
  const svg = getSvgSource(provider);

  return (
    <Image
      src={svg}
      preview={false}
      width={20}
      height={20}
      className="tw-flex tw-align-middle"
      alt="icon"
    />
  );
};

const getOutlineClass = (loading?: boolean, disabled?: boolean) => {
  if (disabled) return styles.buttonDisabledClass;
  if (loading) return styles.buttonLoadingClass;

  return styles.buttonOutlineClass;
};

const SocialButton: React.FC<SocialButtonProps> = ({
  onClick,
  provider,
  label,
  loading,
  disabled,
}) => (
  <AntDesignButton
    size="middle"
    onClick={onClick}
    loading={loading}
    disabled={disabled}
    className={cx(
      getOutlineClass(loading, disabled),
      'tw-w-full tw-rounded-xl tw-border tw-border-solid tw-border-[--color-border-white] tw-bg-transparent',
    )}
  >
    <div className="tw-flex tw-justify-between tw-w-full">
      <span className="tw-flex tw-items-center tw-justify-start">
        {!loading && getIconImage(provider)}
      </span>

      <span className="tw-px-[4px] tw-text-[14px]">{label || null}</span>
      <span className="tw-w-4" />
    </div>
  </AntDesignButton>
);

export default SocialButton;
